<span
  matTooltipPosition="above"
  [class]="['role-missing', class]"
  [matTooltip]="'Missing permissions for this action' | translate"
>
  <ng-container *ngTemplateOutlet="template"></ng-container>
  <ix-icon name="lock" class="role-missing-icon"></ix-icon>
</span>
